import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import styled from "styled-components";

export const Container = styled.div`
  display: block;
  color: #008c6b;
`;

export const StyledSort = styled(Dropdown)`
  > Button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 158px;
    height: 29px;
    padding: 0 8px 0 10px;
    color: white;
    font-size: 12px;
    font-weight: 600;
    text-align: left;
    background-color: ${props => (props.className === "option-selected" ? props.theme.orangeBackground : "#AFAFAF")};

    &:hover {
      background-color: ${props => (props.className === "option-selected" ? props.theme.orangeBackground : "#A0A0A0")};
      border: ${props =>
        props.className === "option-selected" ? "1px solid " + props.theme.orangeBackground : "1px solid #A0A0A0"};
    }

    &:focus {
      background-color: ${props => (props.className === "option-selected" ? props.theme.orangeBackground : "#A0A0A0")};
      border: ${props =>
        props.className === "option-selected" ? "1px solid " + props.theme.orangeBackground : "1px solid #A0A0A0"};
    }
  }

  > div {
    font-size: 12px;
    background-color: #e4e4e4;
  }

  > .dropdown-toggle::after {
    display: none;
  }

  .svg-inline--fa.fa-w-14 {
    width: 16px;
    height: 16px;
  }
`;

export const StyledRadio = styled(Form.Check)`
  color: gray;
  font-weight: 600;
`;

export const StyledDropdowMenu = styled(Dropdown.Menu)`
  padding: 0;
  white-space: nowrap;

  .row {
    flex-wrap: nowrap;
  }
`;

export const StyledRow = styled(Row)`
  border-bottom: ${props => (props.className === "no-divission" ? 0 : "1px solid lightgray")};
  margin-left: -10px;
  margin-right: 5px;
  padding: 5px 0px 3px 0px;
`;
